import React from 'react';
import singleTenantTables from './single-tenant-tables/index';
import Textarea from '../Textarea';
import markets from '../../markets';
import propertyCategories from '../../property-categories';
import propertyTypes from '../../property-types';
import leaseTypes from '../../lease-types';
import unitedStates from 'united-states';
import request from "arcdynamic-request";
import {stringProps, dateProps, numberProps, vacantChanges, leaseChanges} from "./stnl-fields-to-save";
import Icon from "../Icon";
import svgPlace from "../../svgs/place.svg";
import {stringUStoISO, stringISOtoUS, stringUStoUS, dateToUsString} from '../../date-converter';
import guarantor from '../../guarantor';
import optionsToPurchase from '../../options-to-purchase';
import PrintSingleTenant from "../PrintSingleTenant";
import PrintBOV from "../PrintBOV";
import {getTemplate, bovOfficeFor} from "../PrintBOV/bov-templates";
import {addCommasToNumber, isSeniorAgent, isValidPriceChange} from "../../utils";
import {UNDERWRITING_SINGLE_TENANT, UNDERWRITING_RENT_SCHEDULE} from '../../consts/tables';
import {buildRentScheduleRow} from "./single-tenant-tables/rent-schedule";
import {buildOperatingDataRow} from "./single-tenant-tables/annualized-operating-data";
import plusIcon from "../../svgs/plus-button.svg";
import minusIcon from "../../svgs/minus-button.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_PROPERTY_UNDERWRITING_SINGLE_TENANTS, GET_UNDERWRITING_RENT_SCHEDULE, GET_UNDERWRITING_SINGLE_TENANT_WITH_PROPERTYID } from '../Graphql/Queries/propertiesQuery';
import { UPDATE_UNDERWRITING_RENT_SCHEDULE, UPDATE_UNDERWRITING_SINGLE_TENANT } from '../Graphql/Mutations/propertiesMutation';
import { fetchData, mutateData } from '../Service/graphQlService';
import { getData } from '../../requests/CRUD';
import PopupDialog from '../PopupDialog/PopupDialog';
import { GET_PRICING_ANALYSIS_BY_PRODUCT_TYPE } from '../Graphql/Queries/ProposalQuery';

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');
export const operatingDataNo = 11;
const monthlyRentIndex = 0;
const currentYearsIndex = 0;
const leaseCommencementIndex = 1;
const increaseIndex = 3;

function preProcess(items){
    return items.map((val)=>(val.link.split('?')[0]))
}
const defualtStaticImages = [
    '1dc5da0b5ccd7a2e0647bdb85e81f341d7227787d0790c66b17d497150fa7a9231bbd908a08f35ae39da59b9a8461f97421a7d76c1163bf8b7d70497e33a2c7c_STNL_image_2.jpg',
    '4f35f49f424d9a058e2deb44b690792099973f46137fdf4a2655f93c6b907d1edb796c6db25c1b8d5f2c248ef8934587a02ce1b46f6682895296c2fd98da61f4_STNL_image_3.jpg',
    'a09a999b0841ec7f8886ea6ad6d1a7de245b6d91d6414c6b3240abe99c7aa724802cf90d30df80122efa36cb30986225cb99550dff3fbce32f042b740366a2ec_STNL_image_4.jpg',
    'b5d6c9c57e55eb1bbb6498b8d1b207c95abf096611921a3d053c2ca9e250334af65eda3c3f753827a89eabe30f3e741439654482d28401ce1858b4a5019c6ee1_STNL_image_5.jpg',
    '9065ff19a15d1ae652076b65801a850a730da4350c64c80b5ba5b5249b3957f32f368de5100878005fc23072ca453dbce5e2c4f4012fe27c418b53e7ceb471dd_STNL_image_6.jpg',
    '30c89b78cbbe653bbd5b6adbea9a9c177b60c7f77b992c2b70b28a6c56b5b6ab6fa98db70d320da72a33ec1f5bf7418dde0f45892e75d8869db63b132cd7bb9d_STNL_image_7.jpg',
    'eb0020a25c305a06be6e6af9cd184b90a4874e456b06c06260e058967feb97744470fe54b381a864235b944d9e08502fdbfc6af3316f0099fa4d4231f58d1587_STNL_image_8.jpg',
    'f89d31ddae358e0b9b2333d00947a5ba759fee05f08e724d66447ff8112b0a590dda20fc3c4384e5439664947f5f6044eab261024ad7d46c79d804c26a31fdc3_STNL_image_9.jpg',
    'cf7cd88c9a85eb575a3042302ae3d003ab37abb868bab56d3811efd016ade4a6004343cbec2f260966463942b4c1f5de344b0828cd9fa9930528ef8a37a33191_STNL_image_10.jpg',           
];
export default class UnderwritingSingleTenant extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                tables: singleTenantTables
            },
            original: {
                tables: singleTenantTables
            },
            rentScheduleData: null,
            newData: null,
            underwritingId: null,
            displayPopupSubmit: false,
            isAdditionalPriceVisible: false,
            staticImages:[],
            isBusy: false,
            isDialogueOpen: false,
            dialogTitle:''
        };
        this.client = null;
        this.getUnderwritingData = this.getUnderwritingData.bind(this);
        this.setUnderwritingData = this.setUnderwritingData.bind(this);
        this.onTableValueChange = this.onTableValueChange.bind(this);
        this.onTableValueBlur = this.onTableValueBlur.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.togglePopupMessage = this.togglePopupMessage.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.getStaticImages = this.getStaticImages.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.beforeSubmit = this.beforeSubmit.bind(this);
    }

    static calculateMonthlyRents(tables) {
        const t = cloneDeep(tables);
        const rentScheduleRows = t['rent-schedule'].rows;
        const operatingDataRows = t['annualized-operating-data'].rows;
        Object.keys(rentScheduleRows).forEach(key => {
            if (['0', '1'].includes(key) || !operatingDataRows[key].valueCells[0].value) return;
            const prevIncrease = operatingDataRows[key - 1].valueCells[increaseIndex].getComputedValue(t, key - 1).internalValue;
            if (!prevIncrease) return;
            const prevMonthlyRent = rentScheduleRows[key - 1].valueCells[monthlyRentIndex].value;
            rentScheduleRows[key].valueCells[monthlyRentIndex].value = (prevMonthlyRent * (prevIncrease / 100 + 1)).toFixed(2);
        });

        return t;
    }

    // static calculateLeaseCommencement(tables, closeOfEscrow) { old code 
    //     const t = cloneDeep(tables);
    //     const operatingDataRows = t['annualized-operating-data'].rows;

    //     Object.keys(operatingDataRows).forEach(key => {
    //         const leaseCommencement = t['lease-summary'].rows['lease-commencement'].editable ? t['lease-summary'].rows['lease-commencement'].value || '' : t['lease-summary'].rows['lease-commencement'].getComputedValue(t, '', closeOfEscrow).internalValue;
    //         const leaseExpiration = t['lease-summary'].rows['lease-expiration'].editable ? t['lease-summary'].rows['lease-expiration'].value || '' : t['lease-summary'].rows['lease-expiration'].getComputedValue(t, '', closeOfEscrow).internalValue;

    //         if (leaseExpiration === 'MTM') {
    //             operatingDataRows[0].valueCells[currentYearsIndex].value = leaseExpiration;
    //         }

    //         const currentYears = t['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value;

    //         if (key === '0') {
    //             if (currentYears)
    //                 operatingDataRows[key].valueCells[leaseCommencementIndex].value = leaseCommencement;
    //             return;
    //         }

    //         if (leaseCommencement !== 'MTM' && leaseExpiration !== 'MTM') {
    //             const leaseCommencementDate = new Date(leaseCommencement);
    //             const leaseExpirationDate = new Date(leaseExpiration);
    //             const previousYears = t['annualized-operating-data'].rows[key - 1].valueCells[currentYearsIndex].value;

    //             if (currentYears && previousYears && leaseCommencement) {
    //                 const year = previousYears && previousYears.includes('-') ? parseInt(previousYears.split('-')[1]) : parseInt(previousYears);
    //                 const date = {
    //                     year: leaseCommencementDate.getFullYear() + year,
    //                     month: leaseExpirationDate.getMonth() + 1,
    //                     day: leaseExpirationDate.getDate()
    //                 };

    //                 // Lease Expiration date + 1
    //                 const lastDayOfTheMonth = new Date(date.year, date.month,0).getDate();
    //                 if (date.day === lastDayOfTheMonth) {
    //                     if (date.month === 12) {
    //                         date.month = 1;
    //                         date.year++;
    //                     } else {
    //                         date.month++;
    //                     }
    //                     date.day = 1;
    //                 } else {
    //                     date.day++;
    //                 }
    //                 operatingDataRows[key].valueCells[leaseCommencementIndex].value = year && date.month && date.day && date.year ? stringUStoUS(`${date.month}/${date.day}/${date.year}`) : '';
    //             }
    //         }
    //     });

    //     return t;
    // }

// onlyEmpty: fill only the Commencement cells that are blank, so dates the user
// entered by hand are never overwritten.
static calculateLeaseCommencement(tables, closeOfEscrow, onlyEmpty = false) {
  const t = cloneDeep(tables);
  const operatingDataRows = t["annualized-operating-data"].rows;

  Object.keys(operatingDataRows).forEach((key) => {
    if (onlyEmpty && operatingDataRows[key].valueCells[leaseCommencementIndex].value)
      return;

    const leaseCommencement =
      t["lease-summary"].rows["lease-commencement"].editable
        ? t["lease-summary"].rows["lease-commencement"].value || ""
        : t["lease-summary"].rows["lease-commencement"].getComputedValue(
            t,
            "",
            closeOfEscrow
          ).internalValue;

    const leaseExpiration =
      t["lease-summary"].rows["lease-expiration"].editable
        ? t["lease-summary"].rows["lease-expiration"].value || ""
        : t["lease-summary"].rows["lease-expiration"].getComputedValue(
            t,
            "",
            closeOfEscrow
          ).internalValue;

    // Skip MTM
    if (leaseExpiration === "MTM") {
      operatingDataRows[0].valueCells[currentYearsIndex].value = leaseExpiration;
      return;
    }

    const currentYears =
      t["annualized-operating-data"].rows[key].valueCells[
        currentYearsIndex
      ].value;

    // First row: original commencement
    if (key === "0") {
      if (currentYears)
        operatingDataRows[key].valueCells[leaseCommencementIndex].value =
          leaseCommencement;
      return;
    }

    // Calculate for subsequent rows
    if (leaseCommencement && leaseExpiration) {
      const leaseCommencementDate = new Date(leaseCommencement);
      const previousYears =
        t["annualized-operating-data"].rows[key - 1].valueCells[
          currentYearsIndex
        ].value;

      if (currentYears && previousYears) {
        const previousEndYear = previousYears.includes("-")
          ? parseInt(previousYears.split("-")[1], 10)
          : parseInt(previousYears, 10);

        // Labels such as "Option 1: 21" have no leading number; leave the date for the user
        if (isNaN(previousEndYear)) return;

        const nextCommencement = new Date(
          leaseCommencementDate.getFullYear() + previousEndYear,
          leaseCommencementDate.getMonth(),
          leaseCommencementDate.getDate()
        );

        // Pass a plain YYYY-MM-DD string, not ISO UTC
        const localDateStr = `${nextCommencement.getFullYear()}-${String(
          nextCommencement.getMonth() + 1
        ).padStart(2, "0")}-${String(nextCommencement.getDate()).padStart(
          2,
          "0"
        )}`;

        operatingDataRows[key].valueCells[leaseCommencementIndex].value =
          stringISOtoUS(localDateStr);
      }
    }
  });

  return t;
}

    // Recalculate the Commencement of one row from that row's own Years value, leaving
    // every other row untouched. Years "0" or "1" start at lease commencement, "N" or
    // "N-M" start N - 1 years after it, and "Option 1: 21" is read as 21.
    static calculateRowCommencement(tables, rowKey, closeOfEscrow) {
        const t = cloneDeep(tables);
        const row = t['annualized-operating-data'].rows[rowKey];
        const leaseCommencementRow = t['lease-summary'].rows['lease-commencement'];
        const leaseCommencement = leaseCommencementRow.editable
            ? leaseCommencementRow.value || ''
            : leaseCommencementRow.getComputedValue(t, '', closeOfEscrow).internalValue;

        const years = String(row.valueCells[currentYearsIndex].value || '');
        const startYear = parseInt(years.split(':').pop().trim(), 10);
        if (!leaseCommencement || leaseCommencement === 'MTM' || isNaN(startYear))
            return t;

        const leaseCommencementDate = new Date(leaseCommencement);
        if (isNaN(leaseCommencementDate.getTime()))
            return t;

        const commencement = new Date(
            leaseCommencementDate.getFullYear() + Math.max(startYear - 1, 0),
            leaseCommencementDate.getMonth(),
            leaseCommencementDate.getDate()
        );
        row.valueCells[leaseCommencementIndex].value = dateToUsString(commencement);
        return t;
    }


    componentDidMount() {
        if(this.client){
        this.getUnderwritingData();
        let type = this.props.data.category === 'apartments'? 'apartments' : this.props.data.category+'-STNL';
        if(((this.props.data.single_tenant_subcategory && this.props.data.single_tenant_subcategory.toLowerCase().includes("vacant")) || (this.props.data.lease_type && this.props.data.lease_type.toLowerCase().includes("vacant")))){
            type = type+'-vacant';
        }
        this.getStaticImages(type);
        }
    }

    getUnderwritingData(isSaved) {
        let data = cloneDeep(this.state.data);
        let token = localStorage.getItem('authToken');
        // Set the dropdown values
        data.tables['general-information'].rows['state'].dropdownValues = unitedStates;
        data.tables['general-information'].rows['market'].dropdownValues = markets;
        data.tables['general-information'].rows['property-category'].dropdownValues = propertyCategories;
        data.tables['general-information'].rows['property-type'].dropdownValues = propertyTypes;
        data.tables['lease-summary'].rows['lease-type'].dropdownValues = leaseTypes;
        data.tables['lease-summary'].rows['guarantor'].dropdownValues = guarantor;
        data.tables['lease-summary'].rows['options-to-purchase'].dropdownValues = optionsToPurchase;

        if (!this.props.data.arcimedes_row_id) {
            this.setState({
                data: data,
                original: cloneDeep(data)
            });
            return;
        }
        let id = this.props.data.arcimedes_row_id;
        if(id && typeof(id) !== 'string'){
            id = this.props.data.arcimedes_row_id.toString();
        }

        Promise.all([
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_SINGLE_TENANT, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }],
            //     }],
            // }),
            // request(arc.path.api, {
            //     service: 'arcimedes',
            //     action: 'open.datasource.table.Data.getData',
            //     params: ['code', UNDERWRITING_RENT_SCHEDULE, {
            //         filter: [{
            //             'text': this.props.data.ARCIMEDES_ROW_ID,
            //             'code': 'PROPERTY_ID',
            //             'type': 'exact',
            //         }, {
            //             'text': '',
            //             'code': 'DELETED',
            //             'type': 'null',
            //         }],
            //         filterType: 'and',
            //         order: [{
            //             code: 'ARCIMEDES_ROW_ID',
            //             type: 'asc',
            //         }]
            //     }],
            // }),
            // this.client.query({ query: GET_UNDERWRITING_SINGLE_TENANT_WITH_PROPERTYID, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_SINGLE_TENANT_WITH_PROPERTYID, { propertyId: this.props.data.arcimedes_row_id }),
            // this.client.query({ query: GET_UNDERWRITING_RENT_SCHEDULE, variables: { propertyId: this.props.data.arcimedes_row_id },
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            fetchData(GET_UNDERWRITING_RENT_SCHEDULE, { propertyId: this.props.data.arcimedes_row_id }),
        ]).then(res => {
            if (res)
                this.setUnderwritingData(res, data, isSaved);
        });
    }

    setUnderwritingData(res, data, isSaved) {
        const propsData = this.props.data;
        const annualizedOperatingData = data.tables['annualized-operating-data'];
        const rentSchedule = data.tables['rent-schedule'];
        let rentScheduleData = null;

        // Manage data from PROPERTIES table
        stringProps.map(prop => {
            // get property props
            if (propsData.hasOwnProperty(prop.key)) {
                data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] || '';
            }
        });

        dateProps.map(prop => {
            // get property props
            if (propsData.hasOwnProperty(prop.key)) {
                data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? stringUStoUS(propsData[prop.key]) : '';
            }
        });

        numberProps.map(prop => {
            // get property props
            
            if (propsData.hasOwnProperty(prop.key)) {

                if (prop.table === 'pricing-rent-matrix' && (prop.key === 'sqft' || prop.key === 'capitalization_rate')) {
                    data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    return
                }
                
                if (prop.withReplace && prop.withToFixed) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')).toFixed(2) : '';
                    return;
                }
                if (prop.withToFixed) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key]).toFixed(2) : '';
                    return;
                }
                if (prop.withReplace) {
                    data.tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    return;
                }
                data.tables[prop.table].rows[prop.tableKey].value = parseFloat(propsData[prop.key]) || '';
            }
        });

        // Manage data from UNDERWRITING_SINGLE_TENANT table
        if (res[0] && res[0].data && Array.isArray(res[0].data.getUnderwritingSingleTenent) && res[0].data.getUnderwritingSingleTenent.length > 0) {
            const recentlyUpdateArray = res[0].data.getUnderwritingSingleTenent.length > 1 ? res[0].data.getUnderwritingSingleTenent.length -1 : 0;
            const result = res[0].data ? res[0].data.getUnderwritingSingleTenent[recentlyUpdateArray] : {};

            stringProps.map(prop => {
                // get underwriting data
                if (!propsData.hasOwnProperty(prop.key)) {
                    const defaultValue = prop.defaultValue ? prop.defaultValue : '';
                    data.tables[prop.table].rows[prop.tableKey].value = result[prop.key] || defaultValue;
                }
            });

            dateProps.map(prop => {
                // get underwriting data
                if (!propsData.hasOwnProperty(prop.key)) {
                    data.tables[prop.table].rows[prop.tableKey].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                }
            });

            numberProps.map(prop => {
                // get underwriting data; also when the property has the key but no value
                // (lot_size is null on the property, while the popup saves it only to underwriting)
                const emptyOnProperty = !prop.hasOwnProperty('fromProps') && !prop.hasOwnProperty('valueCellIndex') &&
                    (propsData[prop.key] === null || propsData[prop.key] === '') && result[prop.key];
                if (!propsData.hasOwnProperty(prop.key) || emptyOnProperty) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (prop.withToFixed) {
                            data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key]).toFixed(2) : defaultValue;
                            return;
                        }
                        data.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = parseFloat(result[prop.key]) || defaultValue;
                    } else {
                        data.tables[prop.table].rows[prop.tableKey].value = parseFloat(result[prop.key]) || '';
                    }
                }
            });

            const addition_type_enum={
                name:'Taxes',
                name2:'Insurance',
                name3:'CAM',
                name4:'Management Fee'
            }

            data.tables['annualized-operating-data'].footerRow.forEach((e,index)=>{
                const _index = index > 1 ? index : '';
                e.valueCells[0].value = result['addition_type'+_index] || addition_type_enum['name'+_index];
                e.valueCells[2].value = parseInt(result['addition_value'+_index]) || '';
            });
        }

        // Manage data from UNDERWRITING_RENT_SCHEDULE table
        if (res[1] && res[1].data && Array.isArray(res[1].data.getUnderwritingRentSchedule)) {
            const result = res[1].data.getUnderwritingRentSchedule;
            rentScheduleData = result;
            const no = result.length > operatingDataNo ? result.length : operatingDataNo;

            rentSchedule.rows = Object.assign({}, new Array(no).fill(null).map((row, index) => {
                const rowData = result[index] ? result[index] : {};
                return buildRentScheduleRow(rowData);
            }));
            const isSaleLeaseBack = data.tables['general-information']['rows']['sale-lease-back'].value;
            annualizedOperatingData.rows = Object.assign({}, new Array(no).fill(null).map((row, index) => {
                const rowData = result[index] ? result[index] : {};
                return buildOperatingDataRow(rowData, isSaleLeaseBack==='Yes');
            }));
            
            if (result && result[0] && !result[0].lease_commencement)
                data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, propsData.close_of_escrow);
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[0].value = (data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables,0).internalValue && data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables,0).internalValue !=="NaN")? data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables,0).internalValue :""
            const bpsChangeValue = data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value;
            const capRate = data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value;
            const anticipatedPrice = bpsChangeValue + capRate
            const conservativePrice = anticipatedPrice + bpsChangeValue
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = isValidPriceChange(data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(anticipatedPrice) ;
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(conservativePrice);
        }

        const leaseType = data.tables['lease-summary'].rows['lease-type'].value;
        data.tables = UnderwritingSingleTenant.changeVacantView(data.tables, leaseType);

        const isSaleLeaseBack = data.tables['general-information'].rows['sale-lease-back'].value;
        data.tables = UnderwritingSingleTenant.changeLeaseView(data.tables, isSaleLeaseBack);
        
        // set sale lease back default to "No" if none of options are selected
        if (!isSaleLeaseBack) {
            data.tables['general-information'].rows['sale-lease-back'].value = "No"
        }

        this.setState({
            data: data,
            original: cloneDeep(data),
            rentScheduleData,
            underwritingId: res[0].data.getUnderwritingSingleTenent[0] ? res[0].data.getUnderwritingSingleTenent[0].arcimedes_row_id : null
        }, () => {
            if (isSaved) this.props.parentSetData({success: 'Saved'});
        });
    }

    setFieldsDisabled(data) {
        const newData = cloneDeep(data);

        stringProps.map(prop => {
            newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        });
        dateProps.map(prop => {
            newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        });
        numberProps.map(prop => {
            if (prop.hasOwnProperty('valueCellIndex')) {
                newData.tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].forceStatic = !prop.hasOwnProperty('forceStatic');
            } else {
                newData.tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
            }
        });

        Object.keys(newData.tables['rent-schedule'].rows).map(key => {
            newData.tables['rent-schedule'].rows[key].valueCells[0].forceStatic = true;
        });

        Object.keys(newData.tables['annualized-operating-data'].rows).map(key => {
            newData.tables['annualized-operating-data'].rows[key].valueCells[0].forceStatic = true;
        });

        return newData;
    }

    togglePopupMessage() {
        this.setState({displayPopupSubmit: !this.state.displayPopupSubmit})
    }

    handleExpand(tableIdentifier) {
        const data = cloneDeep(this.state.data);
        data.tables[tableIdentifier].footerRow.forEach((e,index)=>{
            if(index>0){
                e.valueCells.forEach(cell => {
                    if(cell){
                    cell.hidden = !cell.hidden;
                    }
                });
             }
        })

        this.setState({
            data,
            isAdditionalPriceVisible: !this.state.isAdditionalPriceVisible,
        });
    }

    static changeVacantView(tables, leaseType) {
        const isVacantLeaseType = leaseType === 'Vacant';
        vacantChanges.map(prop => {
            if (prop.hasValueCells) {
                tables[prop.table].rows[prop.rowKey].valueCells.map(cell => {
                    cell[prop.property] = prop.getValue(isVacantLeaseType);
                });
            } else {
                tables[prop.table].rows[prop.rowKey][prop.property] = prop.getValue(isVacantLeaseType);
            }
        });
        return tables;
    }

    static changeLeaseView(tables, saleLeaseBack) {
        const isSaleLeaseBack = saleLeaseBack === 'Yes';
        leaseChanges.map(prop => {
            if (prop.hasValueCells) {
                tables[prop.table].rows[prop.rowKey].valueCells.map(cell => {
                    cell[prop.property] = prop.getValue(isSaleLeaseBack);
                });
            } else {
                tables[prop.table].rows[prop.rowKey][prop.property] = prop.getValue(isSaleLeaseBack);
            }
        });
        return tables;
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex, isFooter) {
        const data = cloneDeep(this.state.data);
        const value = event.currentTarget.value;
        if (isFooter) {
            data.tables[tableIdentifier].footerRow[rowCode].valueCells[columnIndex].value = value;
            if(tableIdentifier==="annualized-operating-data"){
               data.tables[tableIdentifier].footerRow[0].valueCells[2].getComputedValue(data.tables);
            }
        } else if (columnIndex === undefined || columnIndex === null) {
            if (tableIdentifier === 'lease-summary' && rowCode === 'lease-type' &&
                (data.tables[tableIdentifier].rows[rowCode].value !== 'Vacant' && value === 'Vacant' ||
                    data.tables[tableIdentifier].rows[rowCode].value === 'Vacant' && value !== 'Vacant')) {
                data.tables = UnderwritingSingleTenant.changeVacantView(data.tables, value);
            }
            if (tableIdentifier === 'general-information' && rowCode === 'sale-lease-back')
                data.tables = UnderwritingSingleTenant.changeLeaseView(data.tables, value);
            data.tables[tableIdentifier].rows[rowCode].value = value;
        } else {
            data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = value;
            if (tableIdentifier === 'annualized-operating-data' && columnIndex === currentYearsIndex)
                data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].edited = true;
        }


        if(tableIdentifier==='pricing-rent-matrix'&& rowCode==='sqft'){
            data.tables['offering-summary'].rows['gross-leasable-area'].value = +value;
        }
        else if(tableIdentifier==='offering-summary'&& rowCode==='gross-leasable-area'){
            data.tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value = value.toString();
        }

        if(tableIdentifier==='pricing-matrix' && rowCode==='price-psf-change'){
            data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[0].value = value.toString();
        }
        else if(tableIdentifier==='pricing-rent-matrix'&& rowCode==='rent-adjustment'&& columnIndex!==6){
            data.tables['pricing-matrix'].rows['price-psf-change'].valueCells[0].value = value.toString();
        }

        if(tableIdentifier==='offering-summary' && rowCode==='cap-rate'){
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value = value.toString();
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue+ (parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = value ? (parseFloat(value).toFixed(2)+"%"):("-");
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
            
        }
        else if(tableIdentifier==='pricing-rent-matrix'&& rowCode==='base-rent-psf' && columnIndex===6){
            data.tables['offering-summary'].rows['cap-rate'].value = +value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue+ (parseFloat(data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value)))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[3].value = value ? (parseFloat(value).toFixed(2)+"%"):("-");
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
        }

        if(tableIdentifier==='pricing-matrix' && rowCode==='bps-change'){
            data.tables['pricing-rent-matrix'].rows['rent-adjustment'].valueCells[6].value = value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue+ parseFloat(value))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
        }
        else if(tableIdentifier==='pricing-rent-matrix'&& rowCode==='rent-adjustment' && columnIndex===6){
            data.tables['pricing-matrix'].rows['bps-change'].valueCells[0].value = value;
            const changedAnticipatedValue = (parseFloat(value) + parseFloat(data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[6].value))
            const changedConservativeValue = (changedAnticipatedValue+ parseFloat(value))
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[4].value = isValidPriceChange(+changedAnticipatedValue);
            data.tables['pricing-rent-matrix'].rows['price-percentages'].valueCells[5].value = isValidPriceChange(+changedConservativeValue);
            
        }


        if(tableIdentifier==='pricing-rent-matrix'&& rowCode==='base-rent-psf' && columnIndex!==6){
            data.tables['rent-schedule'].rows[0].valueCells[1].value= value
            data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue = value * (data.tables['offering-summary'].rows['gross-leasable-area'].value)
            let annualValue = data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue;
            let monthlyValue = annualValue / 12;
            //let formattedMonthlyValue = (monthlyValue % 1 === 0) ? monthlyValue.toFixed(0) : monthlyValue.toFixed(2);
            data.tables['rent-schedule'].rows[0].valueCells[0].value = monthlyValue.toFixed(2);
        }
        else if (tableIdentifier==="rent-schedule"&& rowCode==="0"){
            data.tables['rent-schedule'].rows[0].valueCells[1].value= '';
            data.tables['annualized-operating-data'].rows[0].valueCells[2].changedValue='';
            data.tables['pricing-rent-matrix'].rows['base-rent-psf'].valueCells[0].value = data.tables['rent-schedule'].rows[0].valueCells[1].getComputedValue(data.tables,0).internalValue;
        }

        this.setState({data: data});
    }

    onTableValueBlur(tableIdentifier, rowCode, event, columnIndex) {
        const data = cloneDeep(this.state.data);
        const value = event.currentTarget.value;


      

        // Editing Years updates only that row's Commencement; monthly rents and the other
        // rows' dates are entered by the user and must not be recalculated.
        if(tableIdentifier === 'annualized-operating-data' && columnIndex === currentYearsIndex){
            // data.tables = UnderwritingSingleTenant.calculateMonthlyRents(data.tables);
            // data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, this.props.data.close_of_escrow);
            const yearsCell = data.tables[tableIdentifier].rows[rowCode].valueCells[currentYearsIndex];
            // only when the value was actually edited, so tabbing through keeps a manual date
            if (!yearsCell.edited) return;
            yearsCell.edited = false;
            data.tables = UnderwritingSingleTenant.calculateRowCommencement(data.tables, rowCode, this.props.data.close_of_escrow);
            this.setState({data: data});
            return;
        }

        if (tableIdentifier === 'lease-summary' && rowCode === 'lease-commencement' ||
            tableIdentifier === 'lease-summary' && rowCode === 'lease-expiration') {
            data.tables = UnderwritingSingleTenant.calculateLeaseCommencement(data.tables, this.props.data.close_of_escrow, true);
            this.setState({data: data});
            return;
        }

        if (columnIndex === undefined || columnIndex === null)
            return;

        if (tableIdentifier === 'rent-schedule') {
            const val = value && !(/^[a-zA-Z]+$/g).test(value) ? parseFloat(value).toFixed(2) : value;
            data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = val;
            // Monthly rent is entered for each row by the user; no cascade from the first 2 rows
            // if (columnIndex === monthlyRentIndex && val &&
            //     (rowCode === '0' && data.tables[tableIdentifier].rows[1].valueCells[columnIndex].value
            //         || rowCode === '1' && data.tables[tableIdentifier].rows[0].valueCells[columnIndex].value))
            //     data.tables = UnderwritingSingleTenant.calculateMonthlyRents(data.tables);
        } else {
            const propIndex = findIndex(numberProps, {tableKey: rowCode});
            if (propIndex >= 0 && numberProps[propIndex].hasOwnProperty('withToFixed'))
                data.tables[tableIdentifier].rows[rowCode].valueCells[columnIndex].value = value ? parseFloat(value).toFixed(2) : '';
        }
        this.setState({data: data});
    }

    addRow() {
        const data = cloneDeep(this.state.data);
        const newRowIndex = Object.keys(data.tables['annualized-operating-data'].rows).length;
        data.tables['annualized-operating-data'].rows[newRowIndex] = buildOperatingDataRow({});
        data.tables['rent-schedule'].rows[newRowIndex] = buildRentScheduleRow({});
        this.setState({data});
    }

    deleteRow(rowIdentifier) {
        const data = cloneDeep(this.state.data);
        ['annualized-operating-data', 'rent-schedule'].map(tableId => {
            const rowsCount = Object.keys(data.tables[tableId].rows).length;
            if (rowsCount <= 1) {
                alert("You can't delete all the rows from the table!");
            } else {
                // move rows up and delete the last one
                for (let index = parseInt(rowIdentifier); index < rowsCount - 1; index++)
                    data.tables[tableId].rows[index] = data.tables[tableId].rows[index + 1];
                delete data.tables[tableId].rows[rowsCount - 1];
            }
        });
        this.setState({data});
    }

    static renderNameCell(row, tableIdentifier = '', stateData = {}) {
        if (row.hidden) return;

        if (tableIdentifier && tableIdentifier === "offering-summary" && Object.keys(stateData).length &&
            stateData.data.tables['general-information'].rows['property-category'].value &&
            stateData.data.tables['general-information'].rows['property-category'].value !== 'industrial' &&
            row.industrySpecific) return;

        return (
            <td className='name-cell'>
                <span className='text'>{row.name}</span>
            </td>
        );
    }

    static renderStaticValueCell(tables, row, rowKey, domKey, closeOfEscrow,preComputedValues,printRentMatrix=false) {
        if (row.hidden) return;

        const displayValue = row.getComputedValue(tables, rowKey, closeOfEscrow,preComputedValues).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} ${!printRentMatrix?'value-cell':'value-cell-header'} ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {row.tooltip ? <span className='cell-tooltip'>{row.tooltip}</span> : null}
            </td>
        );
    }

    static renderPricingCells(tables, row, rowKey, domKey, closeOfEscrow,preComputedValues) {
        if (row.hidden) return;

        const isconservative= domKey.includes("conservative")
        const displayValue = row.getComputedValue(tables, rowKey, closeOfEscrow,preComputedValues).displayValue;
        return (
            <tr>
                 <td className={`${(displayValue === '-' ? 'center-dashes' : '')} ${!isconservative?'value-cell':'value-cell-conservative'} ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {row.tooltip ? <span className='cell-tooltip'>{row.tooltip}</span> : null}
            </td>
            </tr>
           
        );
    }



    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex, hasRowManipulation, isFooter) {
        if (row.hidden) return;

        if (tableIdentifier === "offering-summary" &&
            this.state.data.tables['general-information'].rows['property-category'].value &&
            this.state.data.tables['general-information'].rows['property-category'].value !== 'industrial' &&
            row.industrySpecific
        ) {
            return
        }

        const valueNeedsFormatting = row.valueNeedsFormatting || (row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps'|| row.unit === 'Ft'));
        if (row.forceStatic) {
            return (
                <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    {tableIdentifier === 'general-information' && rowKey === 'google-maps-link' && row.value ?
                        <a className='link' href={row.value} target='_blank'>{row.value}</a>
                        :
                        <span className='text value'>{row.value.toLocaleString()}</span>
                    }
                </td>
            )
        }

        return (
            <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
                {row.type === 'dropdown' ?
                    row.name === 'State' ?
                        <label>
                            <select
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                value={row.value}>
                                <option value=''/>
                                {row.dropdownValues ? row.dropdownValues.filter(el => !el.isTerritory).map(elem =>
                                    <option key={elem.hasOwnProperty('abbr') ? elem.abbr : elem} value={elem.hasOwnProperty('abbr') ? elem.abbr : elem}>{elem.hasOwnProperty('name') ? elem.name : elem}</option>) : null}
                            </select>
                        </label>
                        :
                        <label>
                            <select
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                value={row.value}>
                                <option value=''/>
                                {row.dropdownValues ? row.dropdownValues.map(elem =>
                                    <option key={elem.hasOwnProperty('code') ? elem.code : elem} value={elem.hasOwnProperty('code') ? elem.code : elem}>{elem.hasOwnProperty('name') ? elem.name : elem}</option>) : null}
                            </select>
                        </label>
                    :
                    hasRowManipulation ?
                        <div>
                            <label className={`${valueNeedsFormatting ? 'formatted-number-label' : ''} ${row.type}`}>
                                <input value={row.value}
                                       onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                       onBlur={(event) => this.onTableValueBlur(tableIdentifier, rowKey, event, columnIndex)}
                                       type={row.type !== 'date' ? row.type : null}
                                       placeholder={row.withoutPlaceholder ? '' : (row.type === 'date' ? 'MM/DD/YYYY' : row.unit)}/>
                                <div className="input-display-value">
                                    {row.value && !(/^[a-zA-Z]+$/g).test(row.value) && row.unit === '$' ? row.unit : null}
                                    {row.value ?
                                        row.withDecimals ? Number(row.value).toFixed(2) : addCommasToNumber(row.value)
                                        : null}
                                    {row.value && row.unit !== '$' ? (row.unit === 'Acres' || row.unit === 'SF' || row.unit ==='Ft' ? ` ${row.unit}` : row.unit) : null}
                                </div>
                            </label>
                            <div className="more-button">
                                <div className="dot"/>
                                <div className="dot"/>
                                <div className="dot"/>
                                <div className="row-manipulation-container">
                                    <div className="action-button" onClick={() => this.deleteRow(rowKey)}>Delete row</div>
                                    <div className="action-button" onClick={this.addRow}>Add row</div>
                                </div>
                            </div>
                        </div>
                        :
                        <label className={`${valueNeedsFormatting ? 'formatted-number-label' : ''} ${row.type}`}>
                            <input value={row.value}
                                   onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex, isFooter)}
                                   onBlur={(event) => this.onTableValueBlur(tableIdentifier, rowKey, event, columnIndex)}
                                   type={row.type !== 'date' ? row.type : null}
                                   placeholder={row.withoutPlaceholder ? '' : (row.type === 'date' ? 'MM/DD/YYYY' : row.unit)}/>
                            <div className="input-display-value">
                                {row.value && !(/^[a-zA-Z]+$/g).test(row.value) && row.unit === '$' ? row.unit : null}
                                {row.value ?
                                    row.withDecimals ? Number(row.value).toFixed(2) : addCommasToNumber(row.value)
                                    : null}
                                {row.value && row.unit !== '$' ? (['Acres', 'SF', 'Years','Ft'].includes(row.unit) ? ` ${row.unit}` : row.unit) : null}
                            </div>
                            {row.name === 'Address' ?
                                <a className="link-button"
                                   href={arc.path.base + 'map/' + this.props.data.arcimedes_row_id} target="_blank">
                                    <Icon svg={svgPlace}/>
                                </a>
                                :
                                <a className="link-button" href={row.value} target="_blank">
                                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor" d="M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z"/>
                                    </svg>
                                </a>
                            }
                        </label>
                }
            </td>
        );
    }

    renderTable(tables, tableIdentifier, closeOfEscrow) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map(key => {
            const row = table.rows[key];
            const nameCell = UnderwritingSingleTenant.renderNameCell(row, tableIdentifier, this.state);
            let valueCell;

            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = UnderwritingSingleTenant.renderStaticValueCell(tables, row, key, null, closeOfEscrow);
            }

            return (
                <tr key={key} className={key}>{nameCell}{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>{tableRows}</tbody>
            </table>
        )
    }

    renderTable1(tables, tableIdentifier, closeOfEscrow) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map(key => {
            const row = table.rows[key];
            const nameCell = UnderwritingSingleTenant.renderNameCell(row);
            let valueCell;

            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = UnderwritingSingleTenant.renderStaticValueCell(tables, row, key, null, closeOfEscrow);
            }

            return (
                ['base-rent','rent-adjustment'].includes(row)? <tr key={key} className={key}>{nameCell}{valueCell}</tr> : <tr key={key} className={key}>{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>{tableRows}</tbody>
            </table>
        )
    }

    renderMatrixTable(tableIdentifier,preComputedValues) {
        const tables = this.state.data.tables;
        const table = tables[tableIdentifier];
        const isSaleLeaseBack = tables['general-information']['rows']['sale-lease-back'].value;
        if(tableIdentifier ==='annualized-operating-data' && isSaleLeaseBack!='Yes' && (isSaleLeaseBack=='No' || !isSaleLeaseBack)){                     
            if(table.headerRow.indexOf('Commencement')<0){
                table.headerRow.splice(1,0,"Commencement")
            }
        }
        else{
            const index =table.headerRow.indexOf('Commencement');
            if(index>=0){
                table.headerRow.splice(index,1)
            }
        }
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);

            const rowContent = (
                <tr key={key} className={key}>
                  {table.hasNamesColumn ? nameCell : null}
                  {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                      return <td key={index} className='invisible' />;
                    }
                    if (cell.editable) {
                      const hasRowManipulation = cell.hasRowManipulation;
                      return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                    } else {
                      const domKey = `${key}-${index}`;
                      return UnderwritingSingleTenant.renderStaticValueCell(tables, cell, key, domKey, preComputedValues);
                    }
                  })}
                </tr>
              );

            if (['rent-adjustment', 'conservative'].includes(key)) {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                        <tr style={{ height: key==="rent-adjustment"?"25px":"" }} />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                    </React.Fragment>
                );
            }
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell) => {
                        return (
                            <td className='header-cell' key={cell}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }

                {tableRows}

                {table.footerRow && Array.isArray(table.footerRow) ?
                    table.footerRow.map((row, index) => {
                        return (
                            <tr className='footer-row' key={index}>{Object.keys(row.valueCells).map((key) => {
                                const cell = row.valueCells[key];
                                if (cell && cell.hidden)
                                    return;

                                if (cell && !cell.empty) {
                                    if (cell.hasExpandButton)
                                        return (
                                            <td className='invisible' key={key}>
                                                <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                    <Icon svg={this.state.isAdditionalPriceVisible ? minusIcon : plusIcon}/>
                                                </div>
                                            </td>
                                        );

                                    if (cell.editable)
                                        return this.renderEditableValueCell(tableIdentifier, index, cell, key, null, true);

                                    const cellComputedValue = cell.getComputedValue(tables);
                                    return (
                                        <td key={key}>
                                            <div className={`text${cell.hasExpandButton ? ' with-expand' : ''}`}>
                                                {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                                {
                                                    cell.hasExpandButton &&
                                                    <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                        <Icon svg={plusIcon}/>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    );
                                }
                                return <td className='invisible' key={key}/>;
                            })}</tr>
                        )
                    })
                    :
                    table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                        <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                            const cell = table.footerRow.valueCells[key];
                            if (cell) {
                                const cellComputedValue = cell.getComputedValue(tables);
                                return (
                                    <td key={key}>
                                        <div className='text'>
                                            {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                        </div>
                                    </td>
                                );
                            }
                            return <td className='invisible' key={key}/>;
                        })}</tr>
                        : null
                }
                </tbody>
            </table>
        )
    }

    renderPricingRentMatrix(tableIdentifier,preComputedValues) {
        const tables = this.state.data.tables;
        const table = tables[tableIdentifier];
        const isSaleLeaseBack = tables['general-information']['rows']['sale-lease-back'].value;
        if(tableIdentifier ==='annualized-operating-data' && isSaleLeaseBack!='Yes' && (isSaleLeaseBack=='No' || !isSaleLeaseBack)){                     
            if(table.headerRow.indexOf('Commencement')<0){
                table.headerRow.splice(1,0,"Commencement")
            }
        }
        else{
            const index =table.headerRow.indexOf('Commencement');
            if(index>=0){
                table.headerRow.splice(index,1)
            }
        }
        const headerRowContent = (
            <tr>{table.mainRows.map((cell) => {
                return (
                    <td className='value-cell-header' style={{fontWeight:"bold",backgroundColor:"#f7f7f7"}}>
                        <span className='text'>{cell}</span>
                    </td>
                )
            })}</tr>
        )

        const pricePercentageData = (
            <tr className='percentage-rows'>{table.rows['price-percentages'].valueCells.map((cell) => {
                return (
                    <td className='name-cell'>
                        <span className='text'>{cell.value}</span>
                    </td>
                )
            })}</tr>
        )
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);

            if(row.displayName && row.name!=='Sq Ft'){
              
            const rowContent = (
                    <tr key={key} className={key}>
                        {row.displayName ? nameCell : null}
                        {row.valueCells.map((cell, index) => {
                            if (cell === null) {
                                return <td key={index} className='invisible' />;
                            }
                            if (cell.editable) {
                                const hasRowManipulation = cell.hasRowManipulation;
                                return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                            } else {
                                const domKey = `${key}-${index}`;
                                return UnderwritingSingleTenant.renderStaticValueCell(tables, cell, key, domKey, preComputedValues,'',true);
                            }
                        })}
                    </tr>
                
            );
              

            if (['rent-adjustment', 'conservative'].includes(key)) {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                            <tr style={{ height: key === "rent-adjustment" ? "25px" : "" }} />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={key}>
                            {rowContent}
                    </React.Fragment>
                );
            }
            }
            return ""

        });

        const footerRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if(row.displayName && row.name==='Sq Ft'){
            const rowContent = (
                    <tr key={key} className={key}>
                        <td className='pricing-footer'>
                <span className='text'>{row.name}</span>
                    </td>
                        {row.valueCells.map((cell, index) => {
                            const hasRowManipulation = cell.hasRowManipulation;
                            return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                        })} 
                    </tr>
                
            );
                return (
                    <React.Fragment key={key}>
                            {rowContent}
                    </React.Fragment>
                );
            }
        });

        const contentTableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            if (row.hidden) return;

            const nameCell = UnderwritingSingleTenant.renderNameCell(row);
            if(row.displayName){
                return ;
            }

            const rowContent = (
                <table className='content-table-data'>
                    <tr key={key} className={key}>
                        {row.displayName ? nameCell : null}
                        {row.valueCells.map((cell, index) => {
                            if (cell === null) {
                                return <td key={index} className='invisible' />;
                            }
                            if (cell.editable) {
                                const hasRowManipulation = cell.hasRowManipulation;
                                return this.renderEditableValueCell(tableIdentifier, key, cell, index, hasRowManipulation);
                            } else {
                                const domKey = `${key}-${index}`;
                                return UnderwritingSingleTenant.renderPricingCells(tables, cell, key, domKey, preComputedValues);
                            }
                        })}
                    </tr>
                </table>
                
            );
              

            if (['rent-adjustment', 'conservative'].includes(key)) {
                return (
                    <React.Fragment key={key}>
                        {rowContent}
                            <tr style={{ height: key === "rent-adjustment" ? "25px" : "" }} />
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key={key}>
                         {rowContent}
                    </React.Fragment>
                );
            }
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>
                {table.headerRow && table.headerRow.length ?
                    <tr>{table.headerRow.map((cell) => {
                        return (
                            <td className='header-cell' key={cell}>
                                <div className='text'>{cell}</div>
                            </td>
                        )
                    })}</tr>
                    : null
                }
                    <React.Fragment>
                        {tableRows}
                        <div className='headers-content'>
                            {pricePercentageData}
                            {headerRowContent}
                        </div>
                        <span className='table-content' style={{ display: "flex"}}>
                            {contentTableRows}
                        </span>
                        <div className="footer-content" style={{marginTop:"10px"}}>
                        {footerRows}
                        </div>
                    </React.Fragment>
                

                {table.footerRow && Array.isArray(table.footerRow) ?
                    table.footerRow.map((row, index) => {
                        return (
                            <tr className='footer-row' key={index}>{Object.keys(row.valueCells).map((key) => {
                                const cell = row.valueCells[key];
                                if (cell && cell.hidden)
                                    return;

                                if (cell && !cell.empty) {
                                    if (cell.hasExpandButton)
                                        return (
                                            <td className='invisible' key={key}>
                                                <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                    <Icon svg={this.state.isAdditionalPriceVisible ? minusIcon : plusIcon}/>
                                                </div>
                                            </td>
                                        );

                                    if (cell.editable)
                                        return this.renderEditableValueCell(tableIdentifier, index, cell, key, null, true);

                                    const cellComputedValue = cell.getComputedValue(tables);
                                    return (
                                        <td key={key}>
                                            <div className={`text${cell.hasExpandButton ? ' with-expand' : ''}`}>
                                                {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                                {
                                                    cell.hasExpandButton &&
                                                    <div className='expand-button' onClick={() => this.handleExpand(tableIdentifier)}>
                                                        <Icon svg={plusIcon}/>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    );
                                }
                                return <td className='invisible' key={key}/>;
                            })}</tr>
                        )
                    })
                    :
                    table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                        <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                            const cell = table.footerRow.valueCells[key];
                            if (cell) {
                                const cellComputedValue = cell.getComputedValue(tables);
                                return (
                                    <td key={key}>
                                        <div className='text'>
                                            {cellComputedValue.hasOwnProperty('displayValue') ? cellComputedValue.displayValue : cellComputedValue}
                                        </div>
                                    </td>
                                );
                            }
                            return <td className='invisible' key={key}/>;
                        })}</tr>
                        : null
                }
                </tbody>
            </table>
        )
    }

    

    

    static renderTableContainer(tables, tableIdentifier, tablesToDisplay,isSaleLeaseBack=false) {
        const table = tables[tableIdentifier];
        const extraPading = (tableIdentifier && tableIdentifier === "pricing-matrix-annex" &&
            tables['general-information'].rows['property-category'].value &&
            tables['general-information'].rows['property-category'].value === 'industrial' &&
            tables['offering-summary'].rows['office-to-warehouse'].industrySpecific)?"extra-padding-bottom":"";
        return (
            <div className={`Financials_table_container ${tableIdentifier}-table-container ${extraPading}`} style={{paddingBottom:isSaleLeaseBack? "7.5rem":""}}>
                <h3 className='Financials_table_title'>{table.name}
                    <span className='Financials_table_description'>{table.description}</span>
                </h3>

                {tablesToDisplay.map(table => table)}
            </div>
        )
    }

    onSubmit() {
        const tables = this.state.data.tables;
        const originalTables = this.state.original.tables;
        const rentScheduleData = this.state.rentScheduleData;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.arcimedes_row_id;
        const underwritingData = {};

        if(originalTables['lease-summary'].rows['lease-type'].value == "Vacant" && tables['lease-summary'].rows['lease-type'].value != "Vacant") {
            tables['offering-summary'].rows['price-psf'].value = '';
        }

        if(tables['lease-summary'].rows['lease-type'].value == "Vacant") {
            // Clear Years and Commencement fileds
            Object.entries(tables['annualized-operating-data'].rows).forEach(([key, value]) => {
                tables['annualized-operating-data'].rows[key]['valueCells'][0].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][1].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][2].value = ''
              });

            Object.entries(tables['rent-schedule'].rows).forEach(([key, value]) => {
                tables['rent-schedule'].rows[key]['valueCells'][0].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][1].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['pricing-matrix'].rows).forEach(([key, value]) => {
                if( key == 'bps-change')
                    tables['pricing-matrix'].rows[key]['valueCells'][0].value = 0.0;
                    
            });


            tables['offering-summary'].rows['cap-rate'].value = ''
            tables['lease-summary'].rows['guarantor'].value = '' 
            tables['lease-summary'].rows['increases'].value = '' 
            tables['lease-summary'].rows['lease-commencement'].value = ''
            tables['lease-summary'].rows['lease-expiration'].value = '' 
            tables['lease-summary'].rows['options'].value = '' 
            tables['lease-summary'].rows['options-to-purchase'].value = ''
            tables['general-information'].rows['sale-lease-back'].value = 'No'




        }

        if(tables['general-information'].rows['property-category'].value !=='industrial'){
            tables['offering-summary'].rows['doors'].value = '';
            tables['offering-summary'].rows['clear-height'].value = '';
            tables['offering-summary'].rows['office-to-warehouse'].value = '';
        }

        stringProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
               
            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                }
            }
        });

        dateProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value ? stringUStoISO(tables[prop.table].rows[prop.tableKey].value) : '';
                }
            }
        });

        numberProps.map(prop => {
            if(prop.table!=='pricing-rent-matrix'){
                if (prop.hasOwnProperty('fromProps')) {
                    // set property props
                    if (prop.withReplace) {
                        propsData[prop.key] = addCommasToNumber(tables[prop.table].rows[prop.tableKey].value);
                        return;
                    }
                    propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                } else {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value !== originalTables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value ||
                            prop.hasOwnProperty('defaultValue') && !tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) || defaultValue;
                        }
                    } else {
                        if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].value) || '';
                            propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                        }
                    }
                }
            }
        });

        tables['annualized-operating-data'].footerRow.forEach((e,index)=>{
            if(index>0){
                const obj={};
                let _index = index>1 ? index :'';
                if (e.valueCells[0].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[0].value)
                underwritingData['addition_type'+_index] = e.valueCells[0].value;
                if (e.valueCells[2].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[2].value)
                underwritingData['addition_value'+_index] = e.valueCells[2].value;               
            }
        });
        const noi = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
        if (noi) {
            propsData.net_operating_income= addCommasToNumber(noi);
            propsData.base_rent = propsData.net_operating_income;
        }

        const price = tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue;
        if (price) {
            propsData.list_price = addCommasToNumber(price);
        }

        const sale_lease_back = tables['general-information'].rows['sale-lease-back'].value
        if (sale_lease_back) {
            propsData.sale_lease_back = sale_lease_back;
        }

        const rentSchedule = tables['rent-schedule'].rows;
        const annualizedOperatingData = tables['annualized-operating-data'].rows;
        const newRentScheduleData = [];
        const deletedRows = rentScheduleData ? cloneDeep(rentScheduleData) : [];
        const arcRowIdIndex = annualizedOperatingData[0].valueCells.length - 1;

        Object.keys(rentSchedule).forEach(key => {
            const rentObj = {};
            const rowId = annualizedOperatingData[key].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {arcimedes_row_id: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            if ((originalTables['rent-schedule'].rows[key] &&
                rentSchedule[key].valueCells[monthlyRentIndex].value !== originalTables['rent-schedule'].rows[key].valueCells[monthlyRentIndex].value) ||
                !originalTables['rent-schedule'].rows[key]) {
                rentObj.monthly_rent = rentSchedule[key].valueCells[monthlyRentIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[currentYearsIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.years = annualizedOperatingData[key].valueCells[currentYearsIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[leaseCommencementIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[leaseCommencementIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                // null, not '': the rent schedule service does not turn '' into null the way the single tenant one does
                rentObj.lease_commencement = annualizedOperatingData[key].valueCells[leaseCommencementIndex].value ? stringUStoISO(annualizedOperatingData[key].valueCells[leaseCommencementIndex].value) : null;
            }

            // Set only if there was at least a change and the property exists
            if (Object.keys(rentObj).length && propertyId) {
                rentObj.property_id = propertyId;
                if (rowId)
                    rentObj.arcimedes_row_id = rowId;
                newRentScheduleData.push(rentObj);
            }
        });

        deletedRows.map(row => {
            newRentScheduleData.push({
                arcimedes_row_id: row.arcimedes_row_id,
                deleted: 1,
            });
        });

        if (!propertyId)
            propsData.arcimedes_row_id = this.props.newPropertyId;

        // Sent back the property props
        this.setState({newData: propsData});
        const copypropsData={...propsData}
        //update sqft data in the rent and pricing range 

        const RentSqft= Number(tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value);
        const offeringSummarySqft = Number(originalTables['offering-summary'].rows['gross-leasable-area'].value);
        const originalSqft = Number((copypropsData.sqft).replace(/,/g, ""))

        
        if((offeringSummarySqft===originalSqft) && (originalSqft!==RentSqft)){
            copypropsData.sqft = RentSqft.toLocaleString();
            tables['offering-summary'].rows['gross-leasable-area'].value = RentSqft
        }

        this.props.parentSetData({newData: copypropsData});

        // `fromProps` fields (Property Name, Address, City, State, ZIP, Market, Category,
        // Type, ...) are written into propsData unconditionally and persisted by the parent
        // via parentSetData({newData}). They never land in underwritingData, so a change to
        // one of them was not reflected here — submitting after editing only a property
        // field showed the misleading "No data to update" even though the change was saved.
        // Detect whether any fromProps value actually changed vs the original.
        const changesInPropData = [...stringProps, ...dateProps, ...numberProps].some(prop => {
            if (!prop.hasOwnProperty('fromProps')) return false;
            const row = tables[prop.table] && tables[prop.table].rows[prop.tableKey];
            const originalRow = originalTables[prop.table] && originalTables[prop.table].rows[prop.tableKey];
            if (!row || !originalRow) return false;
            return row.value !== originalRow.value;
        });

        const noChangesDetected = !Object.keys(underwritingData).length && newRentScheduleData.length < 1 && !changesInPropData;
        if (Object.keys(underwritingData).length)
            underwritingData.property_id = propertyId ? propertyId : this.props.newPropertyId;
            underwritingData.property_id = underwritingData.property_id && underwritingData.property_id.toString();
            underwritingData.price_psf = underwritingData.price_psf && underwritingData.price_psf.toString();
            underwritingData.pricing_range_bps_change = underwritingData.pricing_range_bps_change && underwritingData.pricing_range_bps_change.toString();
            underwritingData.lot_size = underwritingData.lot_size && underwritingData.lot_size.toString();
            underwritingData.clear_height = underwritingData.clear_height && underwritingData.clear_height.toString();

            underwritingData.addition_value = underwritingData.addition_value && Number(underwritingData.addition_value);
            underwritingData.addition_value2 = underwritingData.addition_value2 && Number(underwritingData.addition_value2);
            underwritingData.addition_value3 = underwritingData.addition_value3 && Number(underwritingData.addition_value3);
            underwritingData.addition_value4 = underwritingData.addition_value4 && Number(underwritingData.addition_value4);
        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({isBusy: false});
            this.props.parentSetData({success: 'No data to update'});
            return;
        }
        // const hasExtraFields = input.some(newRentScheduleData => {
        //     // Check if the object has more fields than just "arcimedes_row_id"
        //     return Object.keys(newRentScheduleData).some(key => key !== "arcimedes_row_id");
        //   });
        
        // Promise.all([
        //     // request(arc.path.api, {
        //     //     service: 'arcimedes',
        //     //     action: 'open.datasource.table.Data.updateByTableCode',
        //     //     params: [UNDERWRITING_SINGLE_TENANT, {
        //     //         value: [underwritingData],
        //     //     }]
        //     // }),
        //     // this.client.mutate({
        //     //     mutation: UPDATE_UNDERWRITING_SINGLE_TENANT, variables: { input: [underwritingData] },
        //     //     fetchPolicy: "no-cache",
        //     //     context: {
        //     //         headers: {
        //     //             authorization: `Bearer ${token}`,
        //     //         },
        //     //     }
        //     // }),
        //     mutateData(UPDATE_UNDERWRITING_SINGLE_TENANT,{ input: [underwritingData] }),
            
        //     mutateData(UPDATE_UNDERWRITING_RENT_SCHEDULE,{ input: newRentScheduleData }),
        // ]).then(res => {
        //     if (!res || !res[0] || (!res[0].data.createOrUpdateUnderwritingSingleTenent.success && Object.keys(underwritingData).length) ||
        //         !res[1] || (!res[1].data.createOrUpdateUnderwritingRentSchedule.success && newRentScheduleData.length)) {
        //         this.props.parentSetData({error: 'Unidentified Error'});
        //         return;
        //     }

        //     this.getUnderwritingData(true);
        // });


        const isEmptyObject = (obj) => {
            return Object.values(obj).every(value => value === undefined || value === null || value === '');
        };
        
      //convert them to strings  
       [
         "loan_info_down_payment",
         "loan_info_interest_rate",
         "loan_info_amortization",
         "pricing_range_price_psf_change",
         "original_lease_term",
         "addition_value",
         "addition_value2",
         "addition_value3",
         "addition_value4"

       ].forEach((key) => {
         if (
           underwritingData[key] !== undefined &&
           underwritingData[key] !== null
         ) {
           underwritingData[key] = underwritingData[key].toString();
         }
       });


// Round specific numeric fields to the nearest integer and convert them to strings,
// only if the value exists and is a valid number.
[
  "addition_value",
  "addition_value2",
  "addition_value3",
  "addition_value4",
  "appraised_value",
].forEach((key) => {
  if (
    underwritingData[key] !== undefined &&
    underwritingData[key] !== null &&
    underwritingData[key] !== ""
  ) {
    const numberValue = Number(underwritingData[key]);
    if (!isNaN(numberValue)) {
      underwritingData[key] = Math.round(numberValue).toString();
    }
  }
});

        const shouldCallFirstAPI = !isEmptyObject(underwritingData);
      const updatedRentScheduleData = newRentScheduleData.map(item => {
  if ('property_id' in item) {
    return {
      ...item,
      property_id: Number(item.property_id)
    };
  }
  return item;
});
        Promise.all([
            shouldCallFirstAPI
                ? mutateData(UPDATE_UNDERWRITING_SINGLE_TENANT, { input: [underwritingData] })
                : Promise.resolve(null), // Return resolved promise if skipped
        
            mutateData(UPDATE_UNDERWRITING_RENT_SCHEDULE, { input: updatedRentScheduleData }),
        ])
        .then(res => {
        
            let res0Success = true; // Assume success if API was skipped
            if (shouldCallFirstAPI) {
                res0Success = res[0] && res[0].data && res[0].data.createOrUpdateUnderwritingSingleTenent && res[0].data.createOrUpdateUnderwritingSingleTenent.success;
            }
        
            const res1Success = res[1] && res[1].data && res[1].data.createOrUpdateUnderwritingRentSchedule && res[1].data.createOrUpdateUnderwritingRentSchedule.success;
        
            if (!res0Success || (!res1Success && newRentScheduleData.length > 0)) {
                this.setState({ isBusy: false });
                this.props.parentSetData({ error: 'Unidentified Error' });
                return;
            }

            this.setState({ isBusy: false });
            this.getUnderwritingData(true);
        })
        .catch(err => {
            // mutateData throws on a GraphQL error; without this the popup stayed busy and showed nothing
            this.setState({ isBusy: false });
            this.props.parentSetData({ error: err.message || 'Unidentified Error' });
        });
        
        
    }

    onConfirm(){
        this.setState({isDialogueOpen: false});
        this.onSubmit()
    }
    onCancel(){
        this.setState({isDialogueOpen: false, isBusy: false});
    }
    async beforeSubmit(){
        if(this.state.isBusy)return;
        this.setState({isBusy: true});
        
        if(!(["Active", "In Negotiation", "Under Contract"].includes(this.props.data.status) && this.props.data.source === "STRIVE")){
            this.onSubmit();
            return;
        }

        const tables = this.state.data.tables;
        const originalTables = this.state.original.tables;
        const rentScheduleData = this.state.rentScheduleData;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.arcimedes_row_id;
        const underwritingData = {};
        let changesInPropData = false;

        if(originalTables['lease-summary'].rows['lease-type'].value == "Vacant" && tables['lease-summary'].rows['lease-type'].value != "Vacant") {
            tables['offering-summary'].rows['price-psf'].value = '';
        }

        if(tables['lease-summary'].rows['lease-type'].value == "Vacant") {
            // Clear Years and Commencement fileds
            Object.entries(tables['annualized-operating-data'].rows).forEach(([key, value]) => {
                tables['annualized-operating-data'].rows[key]['valueCells'][0].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][1].value = ''
                tables['annualized-operating-data'].rows[key]['valueCells'][2].value = ''
              });

            Object.entries(tables['rent-schedule'].rows).forEach(([key, value]) => {
                tables['rent-schedule'].rows[key]['valueCells'][0].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][1].value = ''
                tables['rent-schedule'].rows[key]['valueCells'][2].value = ''
            });

            Object.entries(tables['pricing-matrix'].rows).forEach(([key, value]) => {
                if( key == 'bps-change')
                    tables['pricing-matrix'].rows[key]['valueCells'][0].value = 0.0;
                    
            });


            tables['offering-summary'].rows['cap-rate'].value = ''
            tables['lease-summary'].rows['guarantor'].value = '' 
            tables['lease-summary'].rows['increases'].value = '' 
            tables['lease-summary'].rows['lease-commencement'].value = ''
            tables['lease-summary'].rows['lease-expiration'].value = '' 
            tables['lease-summary'].rows['options'].value = '' 
            tables['lease-summary'].rows['options-to-purchase'].value = ''
            tables['general-information'].rows['sale-lease-back'].value = 'No'




        }

        if(tables['general-information'].rows['property-category'].value !=='industrial'){
            tables['offering-summary'].rows['doors'].value = '';
            tables['offering-summary'].rows['clear-height'].value = '';
            tables['offering-summary'].rows['office-to-warehouse'].value = '';
        }

        stringProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                changesInPropData=true;
               
            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
                }
            }
        });

        dateProps.map(prop => {
            if (prop.hasOwnProperty('fromProps')) {
                // set property props
                propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value;
            } else {
                // set underwritingData just if the value has been changed
                if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                    underwritingData[prop.key] = tables[prop.table].rows[prop.tableKey].value ? stringUStoISO(tables[prop.table].rows[prop.tableKey].value) : '';
                }
            }
        });

        numberProps.map(prop => {
            if(prop.table!=='pricing-rent-matrix'){
                if (prop.hasOwnProperty('fromProps')) {
                    // set property props
                    if (prop.withReplace) {
                        propsData[prop.key] = addCommasToNumber(tables[prop.table].rows[prop.tableKey].value);
                        return;
                    }
                    propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                    changesInPropData=true;
                } else {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        const defaultValue = prop.defaultValue || '';
                        if (tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value !== originalTables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value ||
                            prop.hasOwnProperty('defaultValue') && !tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value) || defaultValue;
                        }
                    } else {
                        if (tables[prop.table].rows[prop.tableKey].value !== originalTables[prop.table].rows[prop.tableKey].value) {
                            underwritingData[prop.key] = parseFloat(tables[prop.table].rows[prop.tableKey].value) || '';
                            propsData[prop.key] = tables[prop.table].rows[prop.tableKey].value.toString();
                        }
                    }
                }
            }
        });

        tables['annualized-operating-data'].footerRow.forEach((e,index)=>{
            if(index>0){
                const obj={};
                let _index = index>1 ? index :'';
                if (e.valueCells[0].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[0].value)
                underwritingData['addition_type'+_index] = e.valueCells[0].value;
                if (e.valueCells[2].value !== originalTables['annualized-operating-data'].footerRow[index].valueCells[2].value)
                underwritingData['addition_value'+_index] = e.valueCells[2].value;               
            }
        });
        const noi = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
        if (noi) {
            propsData.net_operating_income = addCommasToNumber(noi);
            propsData.base_rent = propsData.net_operating_income;
            changesInPropData=true;
        }

        const price = tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue;
        if (price) {
            propsData.list_price = addCommasToNumber(price);
            changesInPropData = true;
        }

        const sale_lease_back = tables['general-information'].rows['sale-lease-back'].value
        if (sale_lease_back) {
            propsData.sale_lease_back = sale_lease_back;
            changesInPropData = true;
        }

        const rentSchedule = tables['rent-schedule'].rows;
        const annualizedOperatingData = tables['annualized-operating-data'].rows;
        const newRentScheduleData = [];
        const deletedRows = rentScheduleData ? cloneDeep(rentScheduleData) : [];
        const arcRowIdIndex = annualizedOperatingData[0].valueCells.length - 1;

        Object.keys(rentSchedule).forEach(key => {
            const rentObj = {};
            const rowId = annualizedOperatingData[key].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {arcimedes_row_id: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            if ((originalTables['rent-schedule'].rows[key] &&
                rentSchedule[key].valueCells[monthlyRentIndex].value !== originalTables['rent-schedule'].rows[key].valueCells[monthlyRentIndex].value) ||
                !originalTables['rent-schedule'].rows[key]) {
                rentObj.monthly_rent = rentSchedule[key].valueCells[monthlyRentIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[currentYearsIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[currentYearsIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                rentObj.years = annualizedOperatingData[key].valueCells[currentYearsIndex].value;
            }
            if ((originalTables['annualized-operating-data'].rows[key] &&
                annualizedOperatingData[key].valueCells[leaseCommencementIndex].value !== originalTables['annualized-operating-data'].rows[key].valueCells[leaseCommencementIndex].value) ||
                !originalTables['annualized-operating-data'].rows[key]) {
                // null, not '': the rent schedule service does not turn '' into null the way the single tenant one does
                rentObj.lease_commencement = annualizedOperatingData[key].valueCells[leaseCommencementIndex].value ? stringUStoISO(annualizedOperatingData[key].valueCells[leaseCommencementIndex].value) : null;
            }

            // Set only if there was at least a change and the property exists
            if (Object.keys(rentObj).length && propertyId) {
                rentObj.property_id = propertyId;
                if (rowId)
                    rentObj.arcimedes_row_id = rowId;
                newRentScheduleData.push(rentObj);
            }
        });

        deletedRows.map(row => {
            newRentScheduleData.push({
                arcimedes_row_id: row.arcimedes_row_id,
                deleted: 1,
            });
        });

        if (!propertyId)
            propsData.arcimedes_row_id = this.props.newPropertyId;

        // Sent back the property props
        this.setState({newData: propsData});
        const copypropsData={...propsData}
        //update sqft data in the rent and pricing range 

        const RentSqft= Number(tables['pricing-rent-matrix'].rows['sqft'].valueCells[0].value);
        const offeringSummarySqft = Number(originalTables['offering-summary'].rows['gross-leasable-area'].value);
        const originalSqft = Number((copypropsData.sqft).replace(/,/g, ""))

        
        if((offeringSummarySqft===originalSqft) && (originalSqft!==RentSqft)){
            copypropsData.sqft = RentSqft.toLocaleString();
            tables['offering-summary'].rows['gross-leasable-area'].value = RentSqft
        }

        const noChangesDetected = !Object.keys(underwritingData).length && newRentScheduleData.length < 1 && !changesInPropData;
        
        if (Object.keys(underwritingData).length)
            underwritingData.PROPERTY_ID = propertyId ? propertyId : this.props.newPropertyId;

        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) {
            this.setState({isBusy: false});
            this.props.parentSetData({success: 'No data to update'});
            return;
        }

        if(tables['offering-summary'].rows['price'].getComputedValue(tables).internalValue !== originalTables['offering-summary'].rows['price'].getComputedValue(originalTables).internalValue){
            this.setState({isDialogueOpen: true, dialogTitle:'Do you have an Amendment to the Rep Agreement to change the price?'});
        }else{
            this.setState({isDialogueOpen: true, dialogTitle:'Are you sure you want to save this financial data?'});
        }

    }

    async getStaticImages(type){
        const res = await fetchData(GET_PRICING_ANALYSIS_BY_PRODUCT_TYPE, { productType: type });
        if (res && res.data && res.data.getPricingAnalysisByProductType) { this.setState({ staticImages: preProcess(res.data.getPricingAnalysisByProductType.items) }); return preProcess(res.data.getPricingAnalysisByProductType.items); }
    }

    render() {
        const data = this.state.data;
        const tables = data.tables;
        const agents = this.props.agents;
        const propertyImage = this.props.data.website_photo_1 ? this.props.data.website_photo_1 : '';
        const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
       const isSeniorAgentDisable = isSeniorAgent(storedUserData)  && this.props.data.source == "External" || ( this.props.data.source == "STRIVE" && ['Proposal', 'Property Info',].includes(this.props.data.status));
        const disabled = !isSeniorAgentDisable && !(this.props.isSuper || this.props.agentIsCurrentUser && ['Proposal', 'Property Info', 'Off Market', 'Removed'].includes(this.props.data.status));
        const isCategoryRetail = data.tables['general-information'].rows['property-category'].value === 'retail';
        const isPropertyIndustrialVacant = Object.keys(this.props.data).length && this.props.data.type==="STNL" && this.props.data.category==='industrial' && (this.props.data.single_tenant_subcategory ==='Vacant'|| this.props.data.lease_type === 'Vacant');
        const isPropertyIndustrial = Object.keys(this.props.data).length && this.props.data.type==="STNL" && this.props.data.category==='industrial' && !isPropertyIndustrialVacant;
       
        const isCategoryOffice =  Object.keys(this.props.data).length && this.props.data.type==="STNL" && this.props.data.category==='office';
        const isPropertyOfficeVacant = isCategoryOffice && this.props.data.lease_type === 'Vacant';
        const isPropertyRetailVacant = isCategoryRetail && this.props.data.lease_type === 'Vacant';
        const propertyMapProps = {
            LATITUDE: this.props.data.latitude ? parseFloat(this.props.data.latitude) : 0,
            LONGITUDE: this.props.data.longitude ? parseFloat(this.props.data.longitude) : 0,
            NAME: this.props.data.name
        };
        const isSaleLeaseBack= data.tables['general-information'].rows['sale-lease-back'].value ==="Yes"

        // Combinations that have an approved new-template build render through PrintBOV;
        // everything else keeps the existing deck.
        //
        // Vacant properties included, per the business: they were excluded at first because
        // the new page 02 is built around the lease terms and the rent schedule and a vacant
        // property has neither, but the decision is that every property in a built
        // combination gets the new deck. The blocks that have no data to show are dropped
        // rather than printed empty - see OfferingSummarySingle.
        //
        // Market and category come from the underwriting record rather than the property
        // row: both are editable here, they are what the screen above shows, and they are
        // already what isCategoryRetail reads. Falling back to the property keeps this
        // working before the underwriting has been saved for the first time.
        //
        // Market now reaches the office only as `bovOfficeFor`'s fallback, though, because
        // ZIP decides the office and ZIP is not editable on this screen - it is read off the
        // property row. So changing market here no longer changes which deck prints unless
        // that property's ZIP is blank or malformed. That follows from the client's data,
        // where ZIP and market never disagree, but it does remove the only control an agent
        // had over the deck. Giving that back means a property-level BOV office override,
        // which needs a backend column; it is not something this screen can carry.
        const generalInfo = data.tables['general-information'].rows;
        const bovMarket = generalInfo['market'].value || this.props.data.market;
        const bovCategory = generalInfo['property-category'].value || this.props.data.category;
        const bovTemplate = getTemplate(
            bovOfficeFor({zip: this.props.data.zip, market: bovMarket}),
            bovCategory,
            'Single Tenant'
        );

        return (
            <ApolloConsumer>
            {
                client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
            <div>
            <PopupDialog
                    title={this.state.dialogTitle} 
                    isOpen={this.state.isDialogueOpen} 
                    onConfirm={() => { this.onConfirm()}}
                    onCancel={() => {this.onCancel()}}
                />
                {bovTemplate
                    ? <PrintBOV template={bovTemplate} proposalData={this.props.proposalData} tables={tables} propertyImage={propertyImage} agents={agents}/>
                    : <PrintSingleTenant staticImages={this.state.staticImages||defualtStaticImages} isCategoryRetail={isCategoryRetail} isCategoryOffice = {isCategoryOffice} proposalData = {this.props.proposalData} isPropertyIndustrialVacant={isPropertyIndustrialVacant}
                isPropertyIndustrial={isPropertyIndustrial}
                location={this.props.location} tables={tables} propertyImage={propertyImage} agents={agents} propertyMapProps={propertyMapProps} isPropertyOfficeVacant={isPropertyOfficeVacant} isPropertyRetailVacant={isPropertyRetailVacant} isSaleLeaseBack={isSaleLeaseBack}/>
                }
                <div className='Financials_content single_tenant_content'>
                    {/* <div onMouseEnter={this.togglePopupMessage} onMouseLeave={this.togglePopupMessage} className='placeholder-button'/> */}
                    {/* <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={this.onSubmit} disabled={disabled}>Submit</button> */}
                    <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={this.beforeSubmit}>Submit</button>
                    {disabled && this.state.displayPopupSubmit ? <div className='Financials_submit_message'>Don't have permission to save.</div> : null}
                    <div className={`${isSaleLeaseBack ? 'Financials_general_information_columns ':''}`}>
                    <div className={`Financials_general_${isSaleLeaseBack ? 'rent_pricing_tables':'information_table'}`}>
                        {UnderwritingSingleTenant.renderTableContainer(tables, 'general-information', [this.renderTable(tables, 'general-information')],isSaleLeaseBack)}
                    </div>
                    {
                        isSaleLeaseBack &&  <div className='Financials_general_rent_pricing_tables'>
                        {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-rent-matrix', [this.renderPricingRentMatrix('pricing-rent-matrix',this.props.data),])}
                    </div>
                    }
                    </div>
                    
                    <div className='Financials_list_columns'>
                        <div className='Financials_list_column'>
                            {UnderwritingSingleTenant.renderTableContainer(tables, 'offering-summary', [this.renderTable(tables, 'offering-summary')])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'lease-summary', [this.renderTable(tables, 'lease-summary', this.props.data.CLOSE_OF_ESCROW)])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'annualized-operating-data', [this.renderMatrixTable('annualized-operating-data')])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'lease-notes', [
                                <Textarea
                                    type='text'
                                    key=""
                                    name='LEASE NOTES'
                                    readOnly={this.props.isAgent}
                                    value={tables['lease-notes'].rows['lease-notes'].value}
                                    onChange={(event) => this.onTableValueChange('lease-notes', 'lease-notes', event)}
                                    label='Lease notes'/>
                            ])}
                        </div>
                        <div className='Financials_list_column'>
                            {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-matrix', [this.renderMatrixTable('pricing-matrix'),])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'pricing-matrix-annex', [this.renderMatrixTable('pricing-matrix-annex'),])}

                            {UnderwritingSingleTenant.renderTableContainer(tables, 'rent-schedule', [this.renderMatrixTable('rent-schedule')])}
                        </div>
                    </div>
                </div>
            </div>
            )
        }
        }
        </ApolloConsumer>
        );
    }
}